import React from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import BlogsDetailsImage from "../assets/images/blog-detail-img.png";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useNewsDetails } from "../hooks/useNewsDetails";
import UserIcon from '../assets/images/user-1.svg';
import CalendarIcon from '../assets/images/calendar.svg';
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'
import { formatDate } from "../utils/date";
import NewsEvents from "./NewsEvents";

function NewsEventsDetails() {
  const { slug } = useParams();
  const { news, loading, error } = useNewsDetails(slug);
  
  // Get the current URL (don't encode the entire URL)
  const currentUrl = window.location.href;
  
  // Function to handle Facebook share
  const shareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
    console.log('Sharing on Facebook:', url);
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle X/Twitter share
  const shareOnX = () => {
    const text = encodeURIComponent(news?.title || 'Check out this news post');
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(currentUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle LinkedIn share
  const shareOnLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };
  
  // Function to handle Instagram share (copy link method)
  const shareOnInstagram = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert('Link copied! You can now paste it in your Instagram post or story.');
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(`Please copy this link manually: ${currentUrl}`);
    }
  };
  
  // Function to handle YouTube share (copy link method)
  const shareOnYouTube = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert('Link copied! You can now paste it in your YouTube video description or community post.');
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(`Please copy this link manually: ${currentUrl}`);
    }
  };
  
  return (
    <>
      <div className="main blog-details-page">
        <Header />
        <section className="blog-details-section common-padding">
          <Container>
            <Row>
              <Col lg={8} md={12}>
                <article className="blog-article">
                  <div className="article-header">
                    <span className="category-badge">{news?.category_name}</span>
                    <h1 className="article-title">{news?.title}</h1>
                    <p className="article-subtitle">{news?.meta_description}</p>
                  </div>
                  <div className="featured-image">
                    <img 
                      src={news?.image}
                      alt={news?.title || 'Blog image'} 
                    />
                  </div>
                  <div className="article-meta">
                    <div className="author-info">
                        <img src={UserIcon} alt="John Doe" />
                      <span className="author-name">{news?.created_by_first_name} {news?.created_by_last_name}</span>
                    </div>
                    <div className="author-info">
                        <img src={CalendarIcon} alt="27 Apr 2025" />
                      <span className="author-name">{formatDate(news?.created_at)}</span>
                    </div>
                    
                    <div className="social-share">
                      <ul>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnFacebook(); }}>
                            <img src={Facebook} alt="Facebook" />
                          </a>
                        </li> 
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnX(); }}>
                            <img src={X} alt="X" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnInstagram(); }}>
                            <img src={Instagram} alt="Instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnYouTube(); }}>
                            <img src={YouTube} alt="YouTube" />
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); shareOnLinkedIn(); }}>
                            <img src={LinkedIn} alt="LinkedIn" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Article Content */}
                  <div className="article-content">
                    {loading && <p>Loading news...</p>}
                    {!loading && error && <p className="text-danger">{error}</p>}
                    {!loading && !error && !news && <p>No news found.</p>}

                    {!loading && !error && news && (
                      <>
                        {news.description ? (
                          <div dangerouslySetInnerHTML={{ __html: news.description }} />
                        ) : (
                          <p>No news content is available.</p>
                        )}
                      </>
                    )}
                  </div>
                </article>
              </Col>

              {/* Sidebar */}
              {news?.related_news && news.related_news.length > 0 && (
              <Col lg={4} md={12}>
                <aside className="blog-sidebar">
                  <h3>Related News</h3>
                  <div className="sidebar-widget">
                    <ul className="related-blogs-list">
                      {news?.related_news.map((related) => (
                        <li key={related.id} className="related-blog-item">
                          <Link to={`/news-details/${related?.slug || related.id}`} className="blog-link">
                            <span>{related.id}</span>
                            {related.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </Col>
              )}
            </Row>
          </Container>
        </section>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default NewsEventsDetails;